import { createSlotRecipe } from './runtime.js';

const splitViewConfig = {"name":"splitView","slots":["root","panel","dropZoneContainer","dropZone","dragSource"]}

export const splitView = /* @__PURE__ */ createSlotRecipe(splitViewConfig)